import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  servers: [],
  isCalledServers: false,
};

const serversSlice = createSlice({
  name: "servers",
  initialState,
  reducers: {
    setServers(state, action) {
      state.servers = action.payload || [];
    },
    clearServers(state) {
      state.servers = [];
    },
    setCalledServers(state, action) {
      state.isCalledServers = action.payload || false;
    }
  },
});

export const { setServers, clearServers, setCalledServers } =
  serversSlice.actions;

export default serversSlice.reducer;